<template>
  <div>
    <div class="btn-group" role="group" aria-label="Выбор способа восстановления пароля">
      <template v-for="(el, index) in types">
        <input
          :key="`input-${el.title}`"
          :name="`formProfileRemindPassword`"
          :value="index"
          v-model="selected"
          type="radio"
          class="btn-check"
          :id="`btnradioremind${index}`"
          autocomplete="off" />
        <label :key="`label-${el.title}`" class="btn btn-outline-secondary" :for="`btnradioremind${index}`"
          ><font-awesome-icon :icon="`fa-solid ${el.icon}`" /> {{ el.title }}</label
        >
      </template>
    </div>
    <component :is="types[selected].component" :csrf="csrf" class="mt-3" />
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faAt, faUserTie, faPhone } from '@fortawesome/free-solid-svg-icons';
library.add(faAt, faUserTie, faPhone);

import profilePasswordRemindEmail from './profile-password-remind-email.vue';
import profilePasswordRemindSms from './profile-password-remind-sms.vue';

export default {
  data: function () {
    return {
      selected: 0,
      types: [
        {
          title: 'Эл. почта',
          icon: 'fa-at',
          component: 'profilePasswordRemindEmail',
          active: true,
        },
        {
          title: 'Телефон',
          icon: 'fa-phone',
          component: 'profilePasswordRemindSms',
          active: true,
        },
      ],
    };
  },
  props: {
    csrf: {
      type: String,
      default: '',
    },
  },
  components: {
    FontAwesomeIcon,
    profilePasswordRemindEmail,
    profilePasswordRemindSms,
  },
};
</script>
